/*
 * @Author: your name
 * @Date: 2022-11-18 10:04:38
 * @LastEditTime: 2022-12-16 16:48:39
 * @LastEditors: zhang lin
 * @Description: In User Settings Edit
 * @FilePath: /ops-manager-frontend/src/pages/InductiveManage/EnvSet.tsx
 */

import React, { useState, useRef, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { reducerStates } from 'root/store/types';

import alone from 'root/assets/images/standalonebig@2x.png';
import colony from 'root/assets/images/illustrator_colonybig@2x.png';

import DeployForm from './DeployForm';
import DeployIng from './DeployIng';

import messages from './messages';
import styles from './index.less';

interface IProps {
  changeCurrent: any;
}

const EnvSet = (props: IProps) => {
  const intl = useIntl();
  const { changeCurrent } = props;
  const delpoyRef = useRef<any>();
  const [current, setCurrent] = useState('deploy'); // deploy 配置, deploying 纳管
  const [imgSrc, setImgSrc] = useState('alone');
  const { nanotube } = useSelector((state: reducerStates) => state.nanotubeConfig);

  useEffect(() => {
    // 如果是正在纳管中,切换页面
    if (nanotube) {
      setCurrent('deploying');
    }
  }, []);

  return (
    <div className={styles.envForm}>
      <h1 className={styles.envFormTitle}>{intl.formatMessage(messages.addNanobuteTitle)}</h1>
      <h6 className={styles.envFormSubtitle}>{intl.formatMessage(messages.addNanobuteSubtitle)}</h6>
      <div className={styles.envFormBox}>
        <img src={imgSrc === 'alone' ? alone : colony} alt="" />
        {current === 'deploying' ? (
          <DeployIng />
        ) : (
          <DeployForm
            imgSrc={imgSrc}
            changeCurrent={changeCurrent}
            setImgSrc={setImgSrc}
            setCurrent={setCurrent}
            ref={delpoyRef}
          />
        )}
      </div>
    </div>
  );
};

export default EnvSet;
